import React, { useState, useEffect } from "react";
import { navigate } from "gatsby";

import Dimmer from "@/components/shared/dimmer";
import { lockBodyScrolling, restoreBodyScrolling } from "@/helpers";
import DesktopNavbar from "./desktop-navbar";
import MobileNavbar from "./mobile-navbar";
import { MENU_ITEMS } from "./constants";

const handleButtonClick = props => item => event => {
  event.stopPropagation();
  const { onGalleryClick, onFilmClick } = props;

  if (item && item.link) {
    if (item.link === "/gallery") onGalleryClick && onGalleryClick();
    else if (item.link === "/film") onFilmClick && onFilmClick();
    else navigate(item.link, { state: { fromNavbar: true }, replace: true });
  }
};

const Navbar = props => {
  const { location, tourReady, fromNavbar, isDesktop } = props;

  const [isOpen, setIsOpen] = useState(false);
  const [hasMounted, setHasMounted] = useState(false);
  const [hasInitFromNavbar, setHasInitFromNavbar] = useState(false);

  const handleResize = () => setIsOpen(false);
  const handleOpenNavbar = () => setIsOpen(true);
  const handleCloseNavbar = () => setIsOpen(false);
  const handleToggleNavbar = () => setIsOpen(!isOpen);

  // Did mount
  useEffect(() => {
    if (!hasMounted) {
      setTimeout(() => handleCloseNavbar(), 10);
      setHasMounted(true);
    }
  }, []); // eslint-disable-line

  // Lock scrolling when menu is open
  useEffect(() => {
    if (isDesktop || tourReady === false) return;

    if (isOpen) lockBodyScrolling();
    else restoreBodyScrolling();
  }, [isOpen]); // eslint-disable-line

  // Open navbar on page load if navigating via navbar
  useEffect(() => {
    if (fromNavbar && !hasInitFromNavbar) {
      setIsOpen(true);
      setHasInitFromNavbar(true);
    }
  }, [fromNavbar]); // eslint-disable-line

  // Prevent accidental opens when resizing the browser
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  // Initial render for SEO
  if (!hasMounted)
    return (
      <ul style={{ visibility: "hidden" }}>
        {MENU_ITEMS.map(item => (
          <li key={`menu-link-${item.link}`} href={item.link}>
            {item.label}
          </li>
        ))}
      </ul>
    );

  return isDesktop ? (
    <DesktopNavbar
      isOpen={isOpen}
      location={location}
      fromNavbar={fromNavbar}
      onOpen={handleOpenNavbar}
      onClose={handleCloseNavbar}
      onToggle={handleToggleNavbar}
      onNavLinkClick={handleButtonClick(props)}
    />
  ) : (
      <>
        <MobileNavbar
          isOpen={isOpen}
          location={location}
          onNavLinkClick={handleButtonClick(props)}
          onNavButtonClick={handleToggleNavbar}
        />
        {isOpen ? <Dimmer onClick={handleCloseNavbar} /> : null}
      </>
    );
};

export default Navbar;
